exports.components = {
  "component---src-templates-banking-template-tsx": () => import("./../../../src/templates/BankingTemplate.tsx" /* webpackChunkName: "component---src-templates-banking-template-tsx" */),
  "component---src-templates-gdpr-template-tsx": () => import("./../../../src/templates/GdprTemplate.tsx" /* webpackChunkName: "component---src-templates-gdpr-template-tsx" */),
  "component---src-templates-index-template-tsx": () => import("./../../../src/templates/IndexTemplate.tsx" /* webpackChunkName: "component---src-templates-index-template-tsx" */)
}

